import { getRequest, postRequest, patchRequest } from './api';

const optimizationsApi = {
  /**
   * POST → 202 { job_id, status: pending | already_running, platform }
   * @param {string|number} brandId
   * @param {'google'|'meta'} platform
   */
  async generateSuggestions(brandId, platform) {
    const response = await postRequest(
      `/api/generate-suggestions/${brandId}?platform=${encodeURIComponent(platform)}`,
      {}
    );
    if (response.status !== 202) {
      const err = new Error('Respuesta inesperada al generar sugerencias');
      err.response = response;
      throw err;
    }
    return {
      jobId: response.data?.job_id,
      triggerStatus: response.data?.status,
      platform: response.data?.platform ?? platform,
    };
  },

  /** GET job status (pending | running | completed | failed) */
  async getJobStatus(jobId) {
    const response = await getRequest(`/api/job-status/${jobId}`);
    return response.data;
  },

  async getActiveOptimizations() {
    const response = await getRequest('/api/get-active-insights');
    return response;
  },

  async getOptimizations() {
    const response = await getRequest('/api/get-optimizations');
    return response;
  },

  /** Preview/sample cards — same shape as get-optimizations. Backs the dev mock page. */
  async getOptimizationsPreview() {
    const response = await getRequest('/api/get-optimizations-preview');
    return response;
  },

  /** PATCH /api/suggestions/<id>/apply — body shape is archetype-driven (utils/suggestionActions). */
  async applySuggestion(id, body) {
    const response = await patchRequest(`/api/suggestions/${id}/apply`, body);
    return response;
  },

  /** PATCH /api/suggestions/<id>/dismiss — body: { user_feedback? }. */
  async dismissSuggestion(id, body = {}) {
    const response = await patchRequest(`/api/suggestions/${id}/dismiss`, body);
    return response;
  },

  /** PATCH /api/suggestions/<id>/like — body: { is_liked, user_feedback? }. */
  async likeSuggestion(id, body) {
    const response = await patchRequest(`/api/suggestions/${id}/like`, body);
    return response;
  },
};

export default optimizationsApi;
